import env from 'environments';

/**
 * CMS-hosted images must be requested without cookies: the CMS nginx rejects
 * requests whose headers exceed ~8KB (HTTP 431), so customers with bloated
 * .authorify.com cookies see covers that never load. `crossorigin="anonymous"`
 * omits cookies (the CMS serves Access-Control-Allow-Origin: *). Other hosts
 * (S3 buckets) are left untouched since they may not send CORS headers.
 *
 * @param {string} imageUrl Absolute image URL.
 * @returns {'anonymous' | undefined} Value for the img crossOrigin attribute.
 */
export const getImageCrossOrigin = (imageUrl) => {
  try {
    const cmsHost = new URL(env.GRAPHQL_URL).host;
    return new URL(imageUrl).host === cmsHost ? 'anonymous' : undefined;
  } catch {
    return undefined;
  }
};

/**
 * onError handler companion to getImageCrossOrigin: if an anonymous (CORS)
 * image request fails — e.g. the CMS stops sending CORS headers — retry once
 * with the default credentialed request, restoring the previous behavior.
 * Does nothing when the image was not loaded anonymously, so regular load
 * errors keep their original handling.
 *
 * @param {{ target: HTMLImageElement }} event Image error event.
 */
export const retryImageWithCredentials = (event) => {
  const image = event?.target;

  if (!image || !image.crossOrigin) return;

  const { src } = image;
  image.removeAttribute('crossorigin');
  image.src = src;
};
